import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import AppContainer from '../Appcontainer'
import store from '../../store'
import { Provider } from 'react-redux'
import Login from '../../views/pages/LoginPage/Login'
import Otp from '../../views/pages/Otp/Otp'
import ForgotPassword from '../../views/pages/forgotPassword/forgotPassword'
// import ChangePassword from "../../views/pages/ChanagePasword/changePassword";
import ChangePassword from '../../views/pages/ChanagePasword/changePassword'
// import ToastMessage from "../../lib/common/ToastMessage";
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const AppRouter = () => {
  return (
    <div>
      <Provider store={store}>
        <BrowserRouter basename='/'>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/otp' element={<Otp />} />
            <Route path='/forgot' element={<ForgotPassword />} />
            <Route path='/Change_Password' element={<ChangePassword />} />

            <Route path='/*' element={<AppContainer />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  )
}

export default AppRouter
